module.exports = __webpack_public_path__ + "static/media/video-3.da5934af.jpg";